var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallFailedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FD7B7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1781 31.5714H30.0514C26.3943 31.2207 23.0343 29.8595 20.2537 27.7777C20.0482 27.6239 20.0308 27.3243 20.2123 27.1428L22.5363 24.8187C22.6866 24.6684 22.9242 24.6513 23.0966 24.7757C23.1345 24.803 23.1728 24.8305 23.2114 24.8581C23.7181 25.2381 24.4781 25.1114 24.8581 24.7314L25.3648 24.2248C25.7448 23.8448 26.3781 23.5914 27.0114 23.8448L30.4314 24.9848C31.0648 25.2381 31.5714 25.8714 31.5714 26.5048V30.0514C31.5714 30.5581 31.4448 30.9381 31.0648 31.1914C30.8114 31.4448 30.4314 31.5714 30.1781 31.5714Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3918 13.8204C31.7265 13.4856 31.7265 12.9429 31.3918 12.6082C31.0571 12.2735 30.5144 12.2735 30.1796 12.6082L20.4026 22.3852C20.0226 21.9483 19.6606 21.4743 19.2848 20.9314C18.9048 20.4248 18.9048 19.7914 19.4114 19.2848L19.9181 18.7781C20.2981 18.3981 20.5514 17.7648 20.2981 17.1314L19.1581 13.7114C18.9048 13.0781 18.3981 12.5714 17.6381 12.5714H14.0914C13.5848 12.5714 13.2048 12.6981 12.9514 13.0781C12.6981 13.4581 12.5714 13.8381 12.5714 14.2181C12.982 18.4413 14.7779 22.2843 17.5062 25.2816L12.6082 30.1796C12.2735 30.5144 12.2735 31.0571 12.6082 31.3918C12.9429 31.7265 13.4856 31.7265 13.8204 31.3918L31.3918 13.8204Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFailedIcon);
export default __webpack_public_path__ + "static/media/CallFailedIcon.ee1e7478ef3a2e0691bf8ed098412e9a.svg";
export { ForwardRef as ReactComponent };